
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import MainLayout from 'global/MainLayout';
import PageLoader from 'global/Loading/PageLoader';
import SEO from 'global/SEO';
import dynamic from 'next/dynamic';
import useProtectedRoute from 'hooks/useProtectedRoute';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import If from 'global/ErrorHandlers/If';
import useUIConfigStore from 'stores/useUIConfigStore';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

const CommunityFeature = dynamic(() => import('features/community'));
const LeaderDashboard = dynamic(
  () => import('features/community/components/LeaderDashboard'),
);

export default function Community() {
  const { isLoaded } = useProtectedRoute();
  const router = useRouter();
  const remisier = useUIConfigStore((s) => s.getUIValue('remisier'));

  const isLeader = remisier?.isLeader;
  const isCommunityAccessGranted = remisier?.isCommunityAccessGranted;

  useEffect(() => {
    // prevent access for non-enabled user
    if (router.isReady && !isCommunityAccessGranted) {
      router.replace('/stream');
    }
  }, [isCommunityAccessGranted]);

  const client = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false, // default: true
      },
    },
  });

  return (
    <QueryClientProvider client={client}>
      <SEO title="Stockbit Community" />
      <MainLayout maxWidth={1037} isFlexibleWidth>
        <PageLoader loaded={isLoaded} />
        <If condition={isLeader}>
          <LeaderDashboard />
        </If>
        <If condition={!isLeader}>
          <CommunityFeature />
        </If>
      </MainLayout>
    </QueryClientProvider>
  );
}
